// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { types as UserStoreTypes} from './store/user';
import './mixins/firebase_messages';

Vue.config.productionTip = false
Vue.use(require('vue-moment'));
// Set config depending on live of debug
// const firebaseConfig = {
//   // DEBUG
//   apiKey: "AIzaSyDFON7P3h5nk4aFpL1Ho4PoBmlmUNF2NIU",
//   authDomain: "motiplate-dev.firebaseapp.com",
//   databaseURL: "https://motiplate-dev.firebaseio.com",
//   projectId: "motiplate-dev",
//   storageBucket: "motiplate-dev.appspot.com",
//   messagingSenderId: "574920583134",
//   appId: "1:574920583134:web:51c7df6a08aa8028",
//   measurementId: "G-F3JMSCQ0GD"
// }
const firebaseConfig = {
  // LIVE
  apiKey: "AIzaSyAJFIiu4NBbcdmZGB9TNAeCFMlsTqOazUs",
  authDomain: "motiplate-3a8d1.firebaseapp.com",
  databaseURL: "https://motiplate-3a8d1.firebaseio.com",
  projectId: "motiplate-3a8d1",
  storageBucket: "motiplate-3a8d1.appspot.com",
  messagingSenderId: "428032502847",
  appId: "1:428032502847:web:e2999005027b89f5",
  measurementId: "G-T039C69W3L"
}

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
let unsubscribe_PofileUpdate;

firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    store.commit(UserStoreTypes.mutations.SET_USER, {
      id: user.uid,
      name: user.displayName,
      email: user.email
    });

    // Load the profile
    const profileDoc = db.collection("Members").doc(user.uid);
    profileDoc.get().then(snapshot => {
      if (snapshot.exists) {
        // Subscribe to changes - on exit do unsubscribe();
        unsubscribe_PofileUpdate = profileDoc.onSnapshot(profile => {
          store.commit('Profile/set_profile', profile.data());
        });
        store.commit('Profile/subscribeProfileUpdates', unsubscribe_PofileUpdate); 
      } 
      else {
        // Create the profile
        const db = firebase.firestore();
        const toCloneDiet = db.collection("Diets");

        // TODO: Read from template
        let diet;
        toCloneDiet.where('n', '==', 'Weigh-Less').get().then(snapshot => {
          if (snapshot.empty) {
            return;
          }  

          snapshot.forEach(doc => {
            diet = doc.data();
          });

          // Set the start date for the diet
          diet.d = (new Date()).toISOString();
          const profile = { p: {
            d: [diet],
            c: 0,
            g: 0,
            w: 0,
            u: 'kg',
            j: (new Date()).toISOString()
          }}
          db.collection("Members")
          .doc(user.uid).set(profile)
          .then(function() {
            // store.commit('Profile/set_profile', profile);
            // this.navigateHome();

            // Subscribe to changes - on exit do unsubscribe();
            unsubscribe_PofileUpdate = db.collection("Members").doc(user.uid).onSnapshot(profile => {     
              store.commit('Profile/set_profile', profile.data());
            }); 
            store.commit('Profile/subscribeProfileUpdates', unsubscribe_PofileUpdate);
          }) 
          .catch(function() {
            // The document probably doesn't exist.
          });
        })
        .catch(function() {
          // The document probably doesn't exist.
        })
        .finally(function() {
        });
      }
    });
  } else {
    // Logout
    if (unsubscribe_PofileUpdate) {
      store.commit('Profile/unsubscribeProfileUpdates');
    }
    store.commit(UserStoreTypes.mutations.SET_USER, null);
    router.push("/");
  }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
